import {useAllInvestmentAccountsQuery} from '@transactions/graphql';
import * as React from 'react';
import {InvestmentGains} from 'src/InvestmentAccountsView/InvestmentGains';
import {ReturnsMatrix} from 'src/InvestmentAccountsView/ReturnsMatrix';

/**
 * The Performance tab: the per-account returns matrix, then each account's
 * gains split for a period. The slim account-list query only feeds names
 * for the rows — the Overview tab usually has it cached already.
 */
export const InvestmentPerformanceView = () => {
  const {data, loading, error} = useAllInvestmentAccountsQuery();
  const accountNames = React.useMemo(
    () => new Map((data?.allInvestmentAccounts ?? []).map((account) => [account._id, account.name])),
    [data],
  );

  if (loading && data == null) {
    return (
      <div className="flex items-center justify-center p-8">
        <span className="text-muted-foreground">
          Loading investment accounts...
        </span>
      </div>
    );
  }

  // A settled failure must not read as an empty portfolio.
  if (data == null && error != null) {
    return (
      <div className="text-muted-foreground p-8 text-center text-sm">
        Couldn&apos;t load investment accounts.
      </div>
    );
  }

  const accounts = data?.allInvestmentAccounts ?? [];

  // Company stock has gains with no investment account, so they show either way.
  return (
    <div className="flex flex-1 flex-col overflow-y-auto">
      <div className="flex flex-col gap-4 p-4">
        {accounts.length > 0 ? (
          <ReturnsMatrix accounts={accounts} />
        ) : (
          <div className="text-muted-foreground p-4 text-center text-sm">No investment accounts connected.</div>
        )}
        <InvestmentGains accountNames={accountNames} />
      </div>
    </div>
  );
};
